// @flow
import _ from 'lodash'
import type { ImageConfig, ImageSizeRestrictions } from '../types'

export default class ImageSizeRestrictionsMerger {
  configs: Array<ImageSizeRestrictions | ImageConfig>

  constructor(configs: Array<ImageSizeRestrictions | ImageConfig>) {
    this.configs = configs
  }

  minWidth() {
    return _.max(_.map(this.configs, (config) => config.minWidth)) || 0
  }

  minHeight() {
    return _.max(_.map(this.configs, (config) => config.minHeight)) || 0
  }

  maxWidth() {
    return _.min(_.map(this.configs, (config) => config.maxWidth)) || 0
  }

  maxHeight() {
    return _.min(_.map(this.configs, (config) => config.maxHeight)) || 0
  }

  restrictions(): ImageSizeRestrictions {
    return {
      minWidth: this.minWidth(),
      minHeight: this.minHeight(),
      maxWidth: this.maxWidth(),
      maxHeight: this.maxHeight()
    }
  }
}
